import React from 'react';
import { Dropdown, InputGroup } from 'react-bootstrap';
import FieldGroup from '../field-group';
import './style.css';

const FilterDropdown = (props) => {
  function getOptions() {
    if (!props.options || !props.options.length) return null;
    return props.options.map((type) => (
      <Dropdown.Item onClick={props.handleDropdownChange} key={type} id={type}>
        {type}
      </Dropdown.Item>
    ));
  }

  return (
    <InputGroup className='filterDrownContainer'>
      <FieldGroup
        controlId={props.id}
        formValuesValidationState={props.formValuesValidationState}
        hasBeenSubmitted={props.hasBeenSubmitted}
        type='text'
        pparent={props.parent}
        name={props.name}
        value={props.value}
        handleChange={props.handleInputDropdownChange}
        helpText={props.helpText}
        label={props.label}
        className='filterDropdownInput'
      />
      <Dropdown
        as={InputGroup.Append}
        variant='outline-secondary'
        title=''
        id='input-group-dropdown'
        show={props.showDropdown}
      >
        <Dropdown.Toggle
          variant='outline-secondary'
          id='dropdown-basic'
          onClick={props.onToggle}
        />
        <Dropdown.Menu>
          {getOptions()}
          <Dropdown.Divider />
          <Dropdown.Item
            onClick={
              props.isOtherSelect
                ? props.handleInputDropdownChange
                : props.handleDropdownChange
            }
            id='other'
          >
            Other..
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </InputGroup>
  );
};

export default FilterDropdown;
